export const tokens = {
  primary: "#BBDA62",
  primary600: "#A6C44E",
  primaryFaint: "rgba(187,218,98,0.12)",
  surface: "#1C1D21",
  surface100: "#26272C",
  surface200: "#33343A",
  ink: "#101010",
  ink2: "#4D4D4D",
  ink3: "#A4A4A4",
  white: "#FFFFFF",
  alert: {
    critical: "#B00020",
    warning: "#FB8C00",
    info: "#1976D2",
    success: "#388E3C",
    fire: "#E74C3C",
  },
  radius: { card: 16, chip: 9999, control: 10 },
  shadow: {
    glow:
      "0 3px 12px 1px rgba(187,218,98,0.25), 0 2px 8px rgba(255,255,255,0.10)",
    depth:
      "0 8px 16px rgba(0,0,0,0.45), 0 0 24px 2px rgba(187,218,98,0.10)",
    card: "0 4px 16px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06)",
  },
} as const;
